<p class="state-label state-label__color--{{ color }} state-label__bg--{{ background }}">
  {{ label }}
</p>
